import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import { HomePageLayout } from 'commons/models/homePage.model';
import { addNewVersionLayout, getHomePageLayoutFormattedData, isParentLayoutExist } from '../../utils/helper';
import { IVersionBasedHomePageLayout } from '../../utils/model';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();

	const appendDataToLayoutsState = (createdData: IVersionBasedHomePageLayout) => {
		setShowLoader(true);
		try {
			const versionSupportedLayout: IVersionBasedHomePageLayout = getHomePageLayoutFormattedData(
				createdData.minAppVersion,
				createdData.maxAppVersion,
				createdData.bucket,
				[] as HomePageLayout[]
			);

			if (isParentLayoutExist(versionSupportedLayout)) {
				showAlert('Version range combination already exists', { type: 'error' });
				return;
			}

			addNewVersionLayout(versionSupportedLayout);
			showAlert('New Versions created');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: IVersionBasedHomePageLayout) => {
		appendDataToLayoutsState(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
